import { useEffect } from 'react';
import { defaultTheme } from '../configs/Theme/index.es.js';
import { themeColor } from '../configs/Colors/index.es.js';
import generate from '../configs/Colors/generate.es.js';

const formatDateTime = (date, type) => {
    const dateStr = date.toLocaleDateString('en-GB');
    const timeStr = date.toLocaleTimeString('vi-VN').slice(0, 5);
    switch (type) {
        case 'date':
            return dateStr;
        case 'time':
            return timeStr;
        default:
            return `${dateStr} ${timeStr}`;
    }
};
const useClickOutside = (ref, handler) => {
    useEffect(() => {
        const listener = (event) => {
            if (!ref.current || ref.current.contains(event.target))
                return;
            handler(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        document.addEventListener('click', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
            document.removeEventListener('click', listener);
        };
    }, [ref, handler]);
};
const generateTheme = (baseColor) => {
    return Object.assign(Object.assign({}, defaultTheme), { colors: Object.assign(Object.assign(Object.assign({}, themeColor), generate(baseColor.primary, 'primary')), generate(baseColor.secondary, 'secondary')) });
};
const pixelParse = (value) => {
    if (typeof value === 'number')
        return `${value}px`;
    return value;
};
const getScrollbarWidth = () => {
    let width = 0;
    if (typeof window !== 'undefined') {
        if (document.body.scrollHeight <= window.innerHeight)
            return 0;
        if (window.scrollbarWidth &&
            document.body.scrollHeight > window.innerHeight) {
            return window.scrollbarWidth;
        }
        const outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll';
        document.body.appendChild(outer);
        const inner = document.createElement('div');
        outer.appendChild(inner);
        width = outer.offsetWidth - inner.offsetWidth;
        outer.parentNode.removeChild(outer);
    }
    return width;
};
const toArray = (candidate) => {
    if (candidate === undefined || candidate === false)
        return [];
    return Array.isArray(candidate) ? candidate : [candidate];
};
const omit = (obj, fields) => {
    const clone = Object.assign({}, obj);
    if (Array.isArray(fields)) {
        fields.forEach((key) => {
            delete clone[key];
        });
    }
    return clone;
};
const mergeCls = (...cls) => {
    return cls.filter(Boolean).join(' ');
};
const uid = () => {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
};

export { formatDateTime, generateTheme, getScrollbarWidth, mergeCls, omit, pixelParse, toArray, uid, useClickOutside };
